import {useState} from "react";

const useToggleView = () => {


    const [listView, setListView] = useState(true)
    const [ganttView, setGantView] = useState(false)

    const toggleListView= () => {
        setListView(true)
        setGantView(false)
    }
    const toggleGantView = () => {
        setGantView(true)
        setListView(false)
    }

    return {listView, ganttView, toggleListView, toggleGantView}
}

export default useToggleView